if (document.getElementById("socialMediaLinks")) {
    const socialMediaReviewLinksWrapper =
        document.getElementById("socialMediaLinks");
    const socialMediaReviewLinkButtons =
        socialMediaReviewLinksWrapper.querySelectorAll("button");

    socialMediaReviewLinkButtons.forEach((link) => {
        link.addEventListener("click", (e) => {
            let span = link.querySelector(".thankYouMessage");

            if (document.getElementById("email")) {
                let hiddenEmail = document.getElementById("hiddenEmail");
                let email = document.getElementById("email");
                hiddenEmail.value = email.value;
            }
            window.open(link.dataset.url, "_blank");

            setTimeout(() => {
                link.querySelector(".rounded-t").style.backgroundColor =
                    "#8c8c8c";
                link.querySelector(".rounded-b").style.borderColor = "#8c8c8c";
                let svgPath = link.querySelector('.reviewLinkIcon path');
                let svg = link.querySelector('.reviewLinkIcon');
                svg.setAttribute('viewBox', '0 0 512 512');
                svgPath.setAttribute('d', 'M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z');
                svg.classList.add('w-4');
                svg.style.fill = "yellowgreen";
                span.innerHTML = "Done. Thank you!";
                span.style.color = "#262626";
            }, 2000);
        });
    });
}
